import { Box, Button, Modal, Typography, useMediaQuery, Paper, IconButton, Divider } from "@mui/material";
import { SyntheticEvent } from "react";
import CloseIcon from '@mui/icons-material/Close';
interface MyModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (event: SyntheticEvent) => Promise<void> | void;
    title?: string;
}
const ConfirmationModal: React.FC<MyModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    title = "¿Está seguro que desea realizar la liquidación para el cobro?"
}) => {
    const isSmallScreen = useMediaQuery("(max-width:600px)");

    return (
        <Modal open={isOpen} onClose={onClose}>
            <Paper
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: isSmallScreen ? "90%" : 500,
                    minWidth: isSmallScreen ? 320 : 'auto',
                    maxHeight: "80vh",
                    display: "flex",
                    flexDirection: "column",
                    outline: "none",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        p: 2,
                        bgcolor: "primary.main",
                        color: "white",
                    }}
                >
                    <Typography variant="h6" component="h2">
                        Confirmación
                    </Typography>
                    <IconButton
                        onClick={onClose}
                        sx={{ color: "white" }}
                        aria-label="cerrar"
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Box sx={{ p: 3, overflowY: "auto", flexGrow: 1 }}>
                    <Typography sx={{ mb: 2 }}>
                        {title}
                    </Typography>
                    <Divider />
                </Box>

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    p: 2,
                    borderTop: 1,
                    borderColor: "divider",
                }}>
                    <Button variant="outlined" onClick={onClose}>
                        Cancelar
                    </Button>
                    <Button variant="contained" onClick={onConfirm} color="primary">
                        Confirmar
                    </Button>
                </Box>
            </Paper>
        </Modal>
    );
};

export default ConfirmationModal;
